import TemplatesFilter from "./filter/SlotsTemplatesFilterContainer";
import TemplatesTable from "./table/SlotsTemplatesTableContainer";
import "../slots.scss";
import { Button } from "@pickit/pickit-components";
import TemplateCreationModalContainer from "./templateCreationModal/TemplateCreationModalContainer";
import { SlotsTemplatesPropsType } from "./types";
import TemplateDetailModalContainer from "./templateDetailModal/TemplateDetailModalContainer";
import "./i18n";
import { useTranslation } from "react-i18next";
import MultiErrorAlert from "component/multiErrorAlert/MultiErrorAlert";
import { useCallback } from "react";
import { SlotsConstants } from "constants/slots";
import { compensateTime } from "utils/date";

const SlotsTemplates: React.FC<SlotsTemplatesPropsType> = (props) => {
  const { t } = useTranslation();
  const { testId } = props;

  const renderOverlappedTemplates = useCallback(() => {
    const message =
      props.overlappedTemplates.length === 1 &&
      props.overlappedTemplates[0].day.length === 1
        ? t("templates:singleErrorMessage")
        : t("templates:multipleErrorsMessage");

    const templates = props.overlappedTemplates?.map((template) => {
      return template.day.map((day, index) => {
        const date = SlotsConstants.getWeekName(day);
        const start = compensateTime(template.startAt);
        const finish = compensateTime(template.finishAt);
        return (
          <p
            key={`template-${template.code}-${index}`}
            className="template-error"
            data-testid={`${testId}-error-modal-slot-${index + 1}`}
          >{`${template.code} - ${date} - ${start} a ${finish} hs.`}</p>
        );
      });
    });

    return (
      <>
        <span data-testid={`${testId}-error-modal-message`}>{message}</span>
        {templates}
      </>
    );
  }, [props.overlappedTemplates, t, testId]);

  return (
    <>
      <TemplatesFilter regions={props.regions} testId={`${testId}-filters`} />
      <div className="slots-buttons-container">
        <Button
          onClick={() => props.toggleCreationModalVisibility(true)}
          testId={`${testId}-add-template`}
          label={t("templates:newTemplate")}
          iconName="pencil-alt"
          hierarchy="minimal-alt"
        />
      </div>
      <TemplatesTable testId={`${testId}-table`} />
      <TemplateCreationModalContainer
        onClose={props.onCreationModalClose}
        isOpen={props.showCreationModal}
        regions={props.regions}
        testId={`${testId}-creation`}
      />
      <TemplateDetailModalContainer
        onClose={props.onDetailModalClose}
        isOpen={props.showDetailModal}
        regions={props.regions}
      />
      <MultiErrorAlert
        title={
          props.overlappedTemplates.length === 1
            ? t("templates:singleErrorTitle")
            : t("templates:multipleErrorsTitle")
        }
        isOpen={props.overlappedTemplates?.length > 0}
        onClose={props.clearOverlappedTemplates}
        testId={`${testId}-error-modal`}
      >
        {renderOverlappedTemplates()}
      </MultiErrorAlert>
    </>
  );
};

export default SlotsTemplates;
